/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Col, Row } from "reactstrap";
import { Faq } from "src/components/General/Faq";
import { Link } from "gatsby";
import { FaqItem } from "src/components/General/FaqCollapsible";

export interface GeneralFaqProps {
  contextSpecific?: FaqItem[];
}

const defaultGeneral = [
  {
    title: "What if I have questions?",
    content: (
      <div>
        We're here to make you successful and we love helping out our customers! There are a few ways to reach us:
        <ol>
          <li>
            You can email us at <a href="mailto:info@psychedelic.support">info@psychedelic.support</a>.
          </li>
          <li>Use the chat widget at the bottom right of most pages to ask questions.</li>
          <li>Reach out to us on Slack.</li>
        </ol>
      </div>
    ),
  },
  {
    title: "How do I join the Speaker and Professional Networking series?",
    content: (
      <div>
        More details on the Speaker and Professional Networking Series can be found at{" "}
        <Link to="/monthly-speaker-professional-networking/">this page</Link>. We also send out regular updates in our
        monthly industry newsletter. You can view all of the past content at{" "}
        <a href="https://www.youtube.com/@psychedelicsupport" target="_blank" rel="noreferrer">
          our YouTube channel
        </a>
        .
      </div>
    ),
  },
] as FaqItem[];

export const GeneralFaq: React.FunctionComponent<GeneralFaqProps> = (props: GeneralFaqProps) => {
  let items = defaultGeneral;
  if (props.contextSpecific && props.contextSpecific.length > 0) {
    items = items.concat(props.contextSpecific);
  }
  return (
    <div className="mt-3">
      <Row>
        <Col>General</Col>
      </Row>
      <Faq items={items} />
    </div>
  );
};
